export const STEPPER_ITEM_SIZES = {
    sm: 'sm',
    md: 'md',
} as const
